const prod = {
  url: {
    API_BASE_URL: 'https://vput.by',
  }
}

const dev = {
  url: {
    API_BASE_URL: 'http://localhost:8081'
  }
}

export const config = process.env.NODE_ENV === 'development' ? dev : prod
